import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback, useEffect } from "react";
import { useSnapshotsTableColumns } from "@pages/project-details/project-snapshots/hooks/use-snapshots-table-columns";
import { SNAPSHOTS_SORT_BY_MAP, SNAPSHOTS_TABLE_COLUMN_LABELS } from "@pages/project-details/project-snapshots/snapshots-table-constants";
import { getSortByFromGridSortModel } from "@pages/project-details/project-snapshots/snapshots-table-utils";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { setTableType } from "@store/table/table-slice";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getOpenSnapshotHref, trackOpenSnapshot } from "@pages/project-details/project-snapshots/snapshot-utils";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
/** Listing all the snapshots of a project in a table */
export function SnapshotsTable(t0) {
  const $ = _c(22);
  const {
    snapshots,
    isLoading,
    sortBy,
    setSortBy,
    bulkActionButtons,
    shouldHideCheckbox: t1
  } = t0;
  const shouldHideCheckbox = t1 === undefined ? true : t1;
  const dispatch = useAppDispatch();
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  const columns = useSnapshotsTableColumns();
  const t2 = SNAPSHOTS_SORT_BY_MAP[sortBy];
  let t3;
  if ($[0] !== t2) {
    t3 = [t2];
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sortModel = t3;
  let t4;
  let t5;
  if ($[2] !== dispatch) {
    t4 = () => {
      dispatch(setTableType(TableType.snapshots));
    };
    t5 = [dispatch];
    $[2] = dispatch;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== setSortBy) {
    t6 = newModel => {
      const newSortBy = getSortByFromGridSortModel(newModel);
      setSortBy(newSortBy);
    };
    $[5] = setSortBy;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleSortModelChange = t6;
  let t7;
  if ($[7] !== projectLaunchSettings.defaultOpenProjectTarget || $[8] !== trackAsyncEvent) {
    t7 = async snapshot => {
      const openTarget = projectLaunchSettings.defaultOpenProjectTarget;
      await void trackOpenSnapshot({
        openTarget,
        trackAsyncEvent,
        openFrom: "snapshot-table-row",
        accessLevel: snapshot.accessLevel,
        createdAt: snapshot.createdAt
      });
      const targetHref = getOpenSnapshotHref({
        openTarget,
        snapshotId: snapshot.id
      });
      window.open(targetHref, "_blank", "noopener,noreferrer");
    };
    $[7] = projectLaunchSettings.defaultOpenProjectTarget;
    $[8] = trackAsyncEvent;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleRowClick = t7;
  const handleColumnOrderChange = useHandleColumnOrderChange(TableType.snapshots);
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FaroTableColumnVisibilityMenu labelsMap={SNAPSHOTS_TABLE_COLUMN_LABELS} disabledColumns={["name"]} tableType={TableType.snapshots} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      "& .MuiDataGrid-cell": {
        cursor: "pointer",
        padding: "0"
      },
      "& .MuiDataGrid-columnHeader:hover .drag-handle": {
        display: "flex"
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        width: "100%"
      }
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== bulkActionButtons || $[13] !== columns || $[14] !== handleColumnOrderChange || $[15] !== handleRowClick || $[16] !== handleSortModelChange || $[17] !== isLoading || $[18] !== shouldHideCheckbox || $[19] !== snapshots || $[20] !== sortModel) {
    t10 = <FaroTable entities={snapshots} shouldHideCheckbox={shouldHideCheckbox} uniqueIdKey="id" isLoading={isLoading} columns={columns} onRowClick={handleRowClick} bulkActionButtons={bulkActionButtons} rowHeight={70} tableType={TableType.snapshots} onSortModelChange={handleSortModelChange} sortTrackingSubject="Snapshot" sortModel={sortModel} filterMenuTrigger={t8} onColumnOrderChange={handleColumnOrderChange} sx={t9} />;
    $[12] = bulkActionButtons;
    $[13] = columns;
    $[14] = handleColumnOrderChange;
    $[15] = handleRowClick;
    $[16] = handleSortModelChange;
    $[17] = isLoading;
    $[18] = shouldHideCheckbox;
    $[19] = snapshots;
    $[20] = sortModel;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}